export default {"src":"/_next/static/media/AffordableWomenHealthServices.e1f3ce6d.svg","height":51,"width":45,"blurWidth":0,"blurHeight":0};